export * from './HOCs';
export { default as reducer } from './auth.ducks';



// WEBPACK FOOTER //
// ./src/routes/Auth/index.ts